import useSWR from 'swr'

import { authApi, tokenOptions } from '../../apis'

type UseMeApiProps = {
  token: string
}

export const useMeApi = ({ token }: UseMeApiProps) => {
  const options = tokenOptions(token)

  return useSWR(
    token ? '/me' : null,
    token ? () => authApi.me(options).then((res) => res.data) : null
  )
}
